exports = module.exports = require("../../../../../node_modules/css-loader/lib/css-base.js")(false);
// imports


// module
exports.push([module.id, ".custom-tooltip[data-v-173e956e] {\n  pointer-events: all !important;\n}\n", ""]);

// exports
